import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseResponseDTO } from 'src/app/core/models/app.models';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { ApiService } from 'src/app/shared/services/api.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { environment } from 'src/environments/environment';
import { ConfirmEmail } from 'src/app/modules/authentication/components/models/autentication-dto.models';
import { UserService } from 'src/app/shared/services/user.service';
import { lastValueFrom } from 'rxjs';
import en from 'src/assets/i18n/en';  
import { FormValidationService } from 'src/app/shared/services/form-validation.service'; 
import { AuthenticationActions } from 'src/app/modules/authentication/components/models/authentication-actions.enum'; // Adjust the import path

@Component({
  selector: 'app-forget-email',
  templateUrl: './forget-email.component.html',
  styleUrls: ['../../../authentication/components/authentication/authentication.component.scss'] 
})

export class ForgetEmailComponent  implements OnInit {
  returnUrl: string = '';
  translations = en;
  AppConstants = AppConstants;
  invalidSubmit= false;
  private _ForgetEmailForm!: FormGroup;
  public get ForgetEmailForm(): FormGroup {
    return this._ForgetEmailForm;
  }
  //#endregion
  //#region setters
  public set ForgetEmailForm(value: FormGroup) {
    this._ForgetEmailForm = value;
  }




  constructor(
    private _router: Router,
    private _activeRoute : ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _http: HttpClient,
    private _dialogService: DialogService,
    private _loaderService: LoaderService,
    private _userService: UserService,
    private formValidationService: FormValidationService 
  ) { }

  ngOnInit(): void {
    this.initialize();
    this._activeRoute.queryParams.subscribe(params => this.returnUrl = params['returnUrl']);
  }

  private initialize() {
    this.initializeForm();
  }

  private initializeForm() {
    this._ForgetEmailForm = this._formBuilder.group({
      Email: ['', [Validators.required, Validators.email]]
    }); 
  }

  
  public isFormValid() {
    return this.ForgetEmailForm.valid;
  }

  public onSubmitForm(event: Event) {


    event.preventDefault();
    this.invalidSubmit = false;

    if(this.isFormValid()) {
      let data = this.ForgetEmailForm.getRawValue();
      this.handleValidateUser(data);
    } else {
      this.markFormGroupTouched(this.ForgetEmailForm);
      this.invalidSubmit =true;
    }
  }
  
  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
    });
  }

    //#region API Service
    private createApiService(): ApiService {
      const apiService = new ApiService(this._http);
      apiService['_baseUrl'] = environment.API_URL; // Set the base URL manually
      return apiService;
    }
    //#endregion
  
    //#region Payloads
    private prepareValidateUserRequestPayload(data: any) {
      return data as ConfirmEmail;
    }
    //#endregion
    

    //#region Fire HTTP Requests
    private fireValidateUserRequest(apiService: ApiService, payload: ConfirmEmail) {
      const keyValueParams = { Email: payload.Email };
      const req$ = apiService.post(AppConstants.CONTROLLERS.ACCOUNT, AppConstants.ACTIONS.VerifyEmailPassword, true, environment.APIs_PREFIX, {}, keyValueParams);
      return lastValueFrom(req$);
    } 
  //#endregion

  private async handleValidateUser(data: any) {

    console.log('handleValidateUser called with data:', data); // Debug log
    this._loaderService.showLoader();
    const apiService = this.createApiService();
    const payload = this.prepareValidateUserRequestPayload(data);
    this.fireValidateUserRequest(apiService, payload)
    .then((response: any) => {
      let result = response as unknown as BaseResponseDTO;
      if(result.isSuccess) {
       // this._userService.handleValidAuthentication(result);
        this._userService.email = data.Email;
        this._router.navigate(
          [AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.OTP_Page], 
          { queryParams: { action: AuthenticationActions.ForgetPassword } }
        );
      } else {
        this.formValidationService.setCustomError(this.ForgetEmailForm.get('Email'), result.errorMessageEn);
      }
    })
    .catch((err: HttpErrorResponse) => {
      this._loaderService.hideLoader();
      this.invalidSubmit = true;
     

    })
    .finally(() => {
      this._loaderService.hideLoader();
    });
  }




  

} 
